import { QueryString } from '@/types'

export default function getCurrentTab(query: QueryString): string {
  return typeof query.tab === 'string' && query.tab ? query.tab : 'hotels'
}
